import classNames from "classnames";
import { type FC } from "react";

interface Props {
  className?: string;
}

export const SubHeader: FC<Props> = ({ className }) => {
  return (
    <>
      <section className={classNames(`mt-14 mb-14`, [className])}>
        <h1 className="text-center w-full text-xl font-semibold md:text-3xl xs:text-2xl mt-b xs:mb-3">
          Earn
        </h1>
        <p className="max-w-3xl mx-auto text-center text-sm font-medium md:text-base">
          Provide liquidity to our secure pools and receive continuous earnings
          that grow exponentially.
        </p>
      </section>
    </>
  );
};
